import endpoint from "#src/config/endpoint";
import request from "#src/utils/request";
import type { IEndpointOverviewResponse } from "./types";
import {
  listPolicies,
  listPoliciesNoPaging,
  requestToComply,
  retrieveDetailPolicy,
  updatePolicy,
} from "./policies";
import {
  listDevices,
  retrieveDeviceDetails,
  listDevicesNoPaging,
  listDeviceActivities,
  listDevicePolicies,
  listDeviceSoftwares,
  retrieveDeviceSoftwareStatistics,
  retrieveDeviceStatistics,
  countHosts,
  remoteHost,
  restartHost,
  shutdownHost,
  uninstallHost,
  updateHost,
  createInstallAgent,
  retrieveInstallAgent,
  retrieveSoftware,
  archiveHost,
  enableDeviceBackup,
  enableMultipleDeviceBackup,
  listDeviceDrives,
  retrieveDeviceDrivePath,
  updateFileLabels,
  deleteFileLabels,
  listFileSnapshots,
  restoreFileSnapshot,
} from "./devices";
import {
  createThreatPolicy,
  deleteThreatPolicy,
  updateThreatPolicy,
  listThreatPoliciesNoPaging,
  updateEnabledThreatPolicy,
  changeThreatPolicyPriority,
} from "./threatPrevention";
import {
  listPassports,
  createPassport,
  retrievePassport,
  updatePassport,
  deletePassport,
  changePassportPriority,
} from "./passports";

async function retrieveHostsOverview(
  workspaceId: string
): Promise<IEndpointOverviewResponse> {
  return await request.get<never, IEndpointOverviewResponse>(
    `${endpoint.WORKSPACES}/${workspaceId}/hosts/overview`
  );
}

export const endpointService = {
  retrieveHostsOverview,

  // Devices
  listDevices,
  listDevicesNoPaging,
  retrieveDeviceStatistics,
  retrieveDeviceDetails,
  listDeviceActivities,
  listDevicePolicies,
  listDeviceSoftwares,
  retrieveDeviceSoftwareStatistics,
  retrieveSoftware,

  countHosts,
  updateHost,
  shutdownHost,
  restartHost,
  remoteHost,
  uninstallHost,
  createInstallAgent,
  retrieveInstallAgent,
  archiveHost,
  enableDeviceBackup,
  enableMultipleDeviceBackup,
  retrieveDeviceDrivePath,
  listDeviceDrives,
  updateFileLabels,
  deleteFileLabels,
  listFileSnapshots,
  restoreFileSnapshot,

  // Policies
  listPolicies,
  listPoliciesNoPaging,
  retrieveDetailPolicy,
  updatePolicy,
  requestToComply,

  // Threat prevention
  listThreatPoliciesNoPaging,
  createThreatPolicy,
  updateThreatPolicy,
  updateEnabledThreatPolicy,
  deleteThreatPolicy,
  changeThreatPolicyPriority,

  // Passports
  listPassports,
  createPassport,
  retrievePassport,
  updatePassport,
  deletePassport,
  changePassportPriority,
};
